import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Moment } from "moment-jalaali";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthContext from "../components/auth-context";
import DatePicker from "../components/inputs/date-picker";
import Row from "../components/tailwind/row";
import Col from "../components/tailwind/col";
import PishgamanNgnUsage from "../api/ngnUserUsage";

interface IUsageResult {
  preCallCredit: string;
  usedCredit: string;
  remainingCredit: string;
  calledNumber: string;
  direction: string;
  startTime: string;
  endTime: string;
}
function NgnUsages() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;
  const [fromDate, setFromDate] = useState<Moment | undefined>();
  const [toDate, setToDate] = useState<Moment | undefined>();
  const [usageResult, setUsageResult] = useState<IUsageResult[]>([]);
  const { t } = useTranslation();
  useEffect(() => {
    const ngnApi = new PishgamanNgnUsage(context);
    console.log("PishgamanNgnUsage", activeFileId);
    ngnApi
      .getAll(
        activeFileId!,
        fromDate?.locale("en").format("YYYY-MM-DDT00:00"),
        toDate?.locale("en").format("YYYY-MM-DDT00:00")
      )
      .then((usages) => {
        console.log("PishgamanNgnUsage.Result", usages.result);
        setUsageResult(usages.result);
      })
      .catch((error) => console.error("ngnApi", error));
  }, [fromDate, toDate, context, activeFileId]);

  return (
    <>
      <Row className="my-3">
        <Col>
          <ul className="list-unstyled">
            <li>
              <FontAwesomeIcon
                icon="exclamation-triangle"
                className="w-3 text-orange mr-2"
              />
              {t("Usages.WarningText")}
            </li>
          </ul>
        </Col>
      </Row>
      <div className="card">
        <div className="card-header">
          <h6 className="card-title">فیلتر تاریخ</h6>
        </div>
        <div className="card-body">
          <DatePicker label="از" value={fromDate} onChange={setFromDate} />
          <DatePicker label="تا" value={toDate} onChange={setToDate} />
        </div>
      </div>
      <table className="mb-0 table bg-white table-borderless table-bordered-x brc-secondary-l3 text-dark-m2 radius-1 overflow-hidden">
        <thead className="text-primary text-dark-tp3 bgc-grey-l4 text-90 border-b-1 brc-transparent">
          <th className="griddle-table-heading-cell"> شماره مورد تماس</th>
          <th className="griddle-table-heading-cell">زمان شروع</th>
          <th className="griddle-table-heading-cell">زمان پایان</th>
          <th className="griddle-table-heading-cell"> اعتبار قبلی</th>
          <th className="griddle-table-heading-cell">اعتبار استفاده شده</th>
          <th className="griddle-table-heading-cell"> اعتبار باقی مانده</th>
        </thead>
        {usageResult.map((item: IUsageResult, i: any) => (
          <tr className="griddle-row bgc-h-yellow-l4 d-style" key={i}>
            <td className="griddle-cell">{item.calledNumber}</td>
            <td className="griddle-cell">{item.startTime}</td>
            <td className="griddle-cell">{item.endTime}</td>
            <td className="griddle-cell">{item.preCallCredit}</td>
            <td className="griddle-cell">{item.usedCredit}</td>
            <td className="griddle-cell">{item.remainingCredit}</td>
          </tr>
        ))}
      </table>
    </>
  );
}

export default NgnUsages;
